module.exports = __webpack_public_path__ + "img/cns_email_ios13.766156df.png";